import DOMPurify from 'dompurify';
import { Check, ChevronDown, X, Edit3 } from 'lucide-react';
import StatusBadge from './StatusBadge';

const NewsRequestModal = ({ news, isOpen, onClose, handleChangeStatus, onEdit }) => {
    const parseDateToLocal = (dateString) => {
        if (!dateString) return null;
      
        const cleanDateString = dateString.split('T')[0]; // "2025-04-28"
        const parts = cleanDateString.split('-');
      
        if (parts.length !== 3) return null;
      
        const [year, month, day] = parts.map(Number);
      
        if (isNaN(year) || isNaN(month) || isNaN(day)) return null;
      
        return new Date(year, month - 1, day);
      };
          
    if (!isOpen) return null;

    const renderStatusButtons = () => {
        const buttons = [];
        
        // Botón de editar (siempre disponible)
        buttons.push(
            <button
                key="edit"
                onClick={() => onEdit(news)}
                className="flex items-center gap-1 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors"
            >
                <Edit3 size={16} />
                Editar
            </button>
        );

        if (news.status !== 'approved') {
            buttons.push(
            <button
                key="approve"
                onClick={() => handleChangeStatus(news.id, 'approved')}
                className="flex items-center gap-1 bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 transition-colors"
            >
                <Check size={16} />
                Aprobar
            </button>
            );
        }
        if (news.status !== 'pending') {
            buttons.push(
            <button
                key="pending"
                onClick={() => handleChangeStatus(news.id, 'pending')}
                className="flex items-center gap-1 bg-yellow-500 text-white px-4 py-2 rounded-md hover:bg-yellow-600 transition-colors"
            >
                <ChevronDown size={16} />
                Pendiente
            </button>
            );
        }
        if (news.status !== 'rejected') {
            buttons.push(
            <button
                key="reject"
                onClick={() => handleChangeStatus(news.id, 'rejected')}
                className="flex items-center gap-1 bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 transition-colors"
            >
                <X size={16} />
                Rechazar
            </button>
            );
        }
    
        return buttons;
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animate-fadeIn">
            <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-lg p-8 max-w-4xl w-full max-h-screen overflow-y-auto shadow-lg animate-modalEntry"
            >
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-800">{news.title}</h2>
                <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-700 transition-colors p-2 hover:bg-gray-100 rounded-full"
                >
                <X size={20} />
                </button>
            </div>
    
            <div className="mb-6 bg-gray-50 p-4 rounded-lg">
                <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
                <span className="text-gray-600">Categoría: {news.category}</span>
                <span className="text-gray-600">
                    Fecha: {news.creationDate && parseDateToLocal(news.creationDate).toLocaleDateString()}
                </span>
                <span className="text-gray-600">
                    Autor: {news.company?.trade_name || news.companyName || 'Desconocido'}
                </span>
                    <StatusBadge status={news.status} />
                </div>
            </div>
    
            <div className="mb-6 flex flex-col items-center justify-center gap-4">
                <img src={news.image} alt={news.title} className="w-full object-contain rounded-lg mb-4" loading='lazy' />
            </div>
    
            <div className="mb-4 bg-gray-50 p-4 rounded-lg italic">
                <p
                className="text-gray-700 text-justify"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(news.lead) }}
                ></p>
            </div>
    
            <div className="mb-4 bg-gray-50 p-4 rounded-lg">
                <p
                className="text-gray-700 text-justify"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(news.description) }}
                ></p>
            </div>
    
            <div className="flex items-center justify-between border-t pt-4 flex-wrap gap-2">
                <div className="flex gap-2 flex-wrap">{renderStatusButtons()}</div>
                <button
                onClick={() => onClose()}
                className="flex items-center gap-1 bg-gray-200 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-300 transition-colors"
                >
                Cancelar
                </button>
            </div>
            </div>
        </div>
    );
};

export default NewsRequestModal;